let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("fJv3K")]).then(() => parcelRequire('3R5ta'));